module.exports = __webpack_public_path__ + "img/chrome.ff8356d3.svg";